var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 245.068,
    height: 258.745,
    viewBox: "0 0 245.068 258.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(13272.985 7033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4572",
    "data-name": "Path 4572",
    d: "M334.8,309.879l-62.433,11.1a4.689,4.689,0,0,0-2.767,7.635l11.194,13.3c-29.695,9.931-62.2,5.387-88.945-14.023A92.849,92.849,0,0,1,167.174,301.1c-13.416-22.025-17.717-47.105-12.667-71.336a4.7,4.7,0,0,0-3.383-5.583l-15.068-3.875a4.763,4.763,0,0,0-5.847,3.537,122.27,122.27,0,0,0,12.429,84.748,120.235,120.235,0,0,0,44.2,45.95,122.087,122.087,0,0,0,108.286,8.872c.924-.366,1.845-.784,2.769-1.176l12.579,14.948a4.717,4.717,0,0,0,8.045-1.431L340.1,316.177a4.753,4.753,0,0,0-5.3-6.3Z",
    transform: "translate(-13400.451 -7153.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4573",
    "data-name": "Path 4573",
    d: "M357.49,190.7a120.266,120.266,0,0,0-43.772-45.851c-33.658-20.2-73.225-23.318-108.84-9.205-.927.367-1.844.784-2.768,1.176l-12.659-15.043a4.647,4.647,0,0,0-7.925,1.41l-21.572,59.552a4.839,4.839,0,0,0,5.4,6.412l62.056-11.033a4.824,4.824,0,0,0,2.847-7.856l-11.043-13.123c29.571-9.894,61.916-5.418,88.61,13.765a92.117,92.117,0,0,1,23.849,25.2C346,218.569,350.69,244.4,345.486,269.322a4.67,4.67,0,0,0,3.357,5.543l15.053,3.874a4.809,4.809,0,0,0,5.9-3.571A122.263,122.263,0,0,0,357.49,190.7Z",
    transform: "translate(-13400.451 -7153.121)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5bc38cd357db39c66622172ad678801a.svg";
export { ForwardRef as ReactComponent };